"use client";

import { SLTestimonialCard } from "@/components/cards/SLTestimonialCard";
import { responsivePadding } from "@/lib/consts";
import { testimonialsData } from "@/lib/testimonialsData";
import { Box, Grid } from "@mui/material";
import { important } from "@nvon/react-toolbox";
import { HowManyCards } from "../../other/slCarouselResponsivePresets";
import { SLProgressiveCarousel } from "../../other/SLProgressiveCarousel";

export function SLHomeTestimonialsCarousel() {
  const items = !Array.isArray(testimonialsData)
    ? []
    : testimonialsData.map((testimonial, index) => (
        <Box
          key={testimonial.name}
          sx={{
            px: responsivePadding,
            pl: index === 0 ? important(0) : responsivePadding,
          }}
        >
          <SLTestimonialCard
            index={index}
            image={testimonial.image}
            logo={testimonial.logo}
            citation={testimonial.citation}
            name={testimonial.name}
            role={testimonial.role}
            longDescription={testimonial.longDescription}
          />
        </Box>
      ));

  return (
    <SLProgressiveCarousel
      howManyCards={HowManyCards.OneToTwo}
      carouselItems={items}
      grid={
        <Grid container spacing={4}>
          {Array.isArray(testimonialsData) &&
            testimonialsData.map((testimonial, index) => (
              <Grid
                key={testimonial.name}
                size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
              >
                <Box
                  sx={{
                    px: responsivePadding,
                    pl: index === 0 ? important(0) : responsivePadding,
                  }}
                >
                  <SLTestimonialCard
                    index={index}
                    image={testimonial.image}
                    logo={testimonial.logo}
                    citation={testimonial.citation}
                    name={testimonial.name}
                    role={testimonial.role}
                    longDescription={testimonial.longDescription}
                  />
                </Box>
              </Grid>
            ))}
        </Grid>
      }
    />
  );
}
